import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import Pretext from "./components/Pretext";
import { editPretextsStart } from "redux/chats/chats.actions";
import useTranslation from "hooks/useTranslation";

const getPreTexts = ({ chatsData }) => chatsData.pretexts;
const getAgent = ({ userData }) => userData.agent.data;

const PretextsList = ({
  handleTypeMessage,
  setPretextsContent,
  setDeletingPretext,
  chatInputRef,
}) => {
  const preTexts = useSelector(getPreTexts);
  const agentInfo = useSelector(getAgent);

  const [searchingPretext, setSearchingPretext] = useState("");
  const [editingPretext, setEdittingPRetext] = useState({
    id: null,
    field: null,
    title: "",
    description: "",
  });
  const dispatch = useDispatch();
  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();

  const handleEditPretextInput = (pretext, field) => {
    setEdittingPRetext({
      id: pretext.id,
      field: field,
      title: pretext.q,
      description: pretext.a,
      publicId: pretext.publicId,
    });
  };

  const handleResetState = () => {
    setEdittingPRetext({
      id: null,
      field: null,
      title: "",
      description: "",
    });
  };

  const handleChangeInput = (value, name) => {
    setEdittingPRetext((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleEditPretext = () => {
    const formData = {
      id: editingPretext.id,
      edit: true,
      question: editingPretext.title,
      answer: editingPretext.description,
      addToAll: false,
      publicId: editingPretext.publicId,
    };

    dispatch(editPretextsStart(formData));
  };

  const handleSelectMessage = (value) => () => {
    handleTypeMessage(value);
    chatInputRef.current.focus();
  };

  useEffect(() => {
    handleResetState();
  }, [preTexts]);

  return (
    <>
      <div className="conv__body__footer__cannedmsg_box__header flex flex-ai-c flex-jc-sb">
        <div className="conv__body__footer__cannedmsg_box__header__filter">
          <input
            value={searchingPretext}
            onChange={(e) => setSearchingPretext(e.target.value)}
            type="text"
            placeholder={t("SEARCH_IN_MESSAGES")}
          />
        </div>
        <div className="conv__body__footer__cannedmsg_box__header__actions flex flex-ai-c">
          <div className="conv__body__footer__cannedmsg_box__header__actions__addbtn flex flex-ai-c">
            <button
              onClick={() => setPretextsContent("addPretext")}
              className="btn btn-ghost btn-small"
            >
              {t("ADD_MESSAGE")}
            </button>
          </div>
        </div>
      </div>
      <div className="conv__body__footer__cannedmsg_box__body ">
        <div className="conv__body__footer__cannedmsg_box__body__inner">
          {preTexts.map((item, index) => (
            <Pretext
              item={item}
              index={index}
              searchingPretext={searchingPretext}
              editingPretext={editingPretext}
              handleChangeInput={handleChangeInput}
              handleEditPretext={handleEditPretext}
              handleResetState={handleResetState}
              handleSelectMessage={handleSelectMessage}
              handleEditPretextInput={handleEditPretextInput}
              setPretextsContent={setPretextsContent}
              setDeletingPretext={setDeletingPretext}
              agentInfo={agentInfo}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default PretextsList;
